/**
 * Helper function that returns the string to be displayed in the Badge
 */
export var getCount = function getCount(currentCount, thresholdCount) {
  var count = currentCount;

  if (currentCount > thresholdCount) {
    count = "".concat(thresholdCount, "+");
  }

  return count;
};